import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'YourDataCache';

/**
 * Stores entries and selection state for the active topic.
 * Only YourDataEngine should use this cache directly.
 */
class YourDataCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }
}

const yourDataCache = new YourDataCache();
export default yourDataCache;
